import { PayFitColor } from '../../types/module';

export const applyTextStyles = (
  isDark = false,
  color: PayFitColor = 'blue',
) => {
  let result = '';

  if (isDark) result = 'text-neutral-1';
  if (color === 'blue' && !isDark) result = 'text-blue-301';
  if (color === 'coral' && !isDark) result = 'text-coral-301';
  if (color === 'azur' && !isDark) result = 'text-azur-301';
  if (color === 'yellow' && !isDark) result = 'text-yellow-301';
  if (color === 'purple' && !isDark) result = 'text-purple-301';
  if (color === 'mint' && !isDark) result = 'text-mint-301';

  return result;
};
